module.exports = __webpack_public_path__ + "static/esmer-logo-7c573eef4a192db14e59317cacd4285d.svg";